import React from "react";
import {
  SvgIcon,
  useTheme,
  Divider,
  Tooltip,
  Menu,
  MenuItem,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/MailOutlineSharp";
import DarkThemeIcon from "@mui/icons-material/Brightness4Sharp";
import LightThemeIcon from "@mui/icons-material/BrightnessHighSharp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LanguageIcon from "@mui/icons-material/Language";
import { ReactComponent as GitLabIcon } from "./images/icon-gitlab.svg";
import { useTranslation } from "react-i18next";
import { IconButton } from "../components/icon-button";

interface HeaderMenuProps {
  onThemeChange: () => void;
}

export const HeaderMenu = (props: HeaderMenuProps) => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();

  const [localeAnchorEl, setLocaleAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const localeOpen = Boolean(localeAnchorEl);
  const handleLocaleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setLocaleAnchorEl(event.currentTarget);
  };
  const handleLocaleClose = (locale: string) => {
    setLocaleAnchorEl(null);
    i18n.changeLanguage(locale);
  };
  return (
    <header>
      <nav className="absolute top-0 left-0 right-0 flex gap-1 justify-end z-10 py-1 px-4">
        <Tooltip title={t("menu_contact")}>
          <IconButton
            color="inherit"
            component="a"
            href="mailto:mail@christianfoerg.de"
          >
            <EmailIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title={t("menu_linkedin")}>
          <IconButton
            color="inherit"
            component="a"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.linkedin.com/in/christian-f%C3%B6rg-344482220/"
          >
            <SvgIcon component={LinkedInIcon} />
          </IconButton>
        </Tooltip>
        <Tooltip title={t("menu_gitlab")}>
          <IconButton
            color="inherit"
            component="a"
            target="_blank"
            rel="noopener noreferrer"
            href="https://gitlab.com/christianfoerg"
          >
            <SvgIcon component={GitLabIcon} />
          </IconButton>
        </Tooltip>
        <Divider orientation="vertical" flexItem />
        <Tooltip
          title={
            theme.palette.mode === "light"
              ? t("menu_dark_mode")
              : t("menu_light_mode")
          }
        >
          <IconButton color="inherit" onClick={props.onThemeChange}>
            {theme.palette.mode === "light" ? (
              <DarkThemeIcon />
            ) : (
              <LightThemeIcon />
            )}
          </IconButton>
        </Tooltip>
        <Tooltip title={t("menu_language")}>
          <IconButton
            id="locale-button"
            color="inherit"
            aria-controls={localeOpen ? "locale-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={localeOpen ? "true" : undefined}
            onClick={handleLocaleClick}
          >
            <LanguageIcon />
          </IconButton>
        </Tooltip>
        <Menu
          id="locale-menu"
          anchorEl={localeAnchorEl}
          open={localeOpen}
          onClose={handleLocaleClose}
          MenuListProps={{
            "aria-labelledby": "locale-button",
          }}
        >
          <MenuItem onClick={() => handleLocaleClose("de")}>Deutsch</MenuItem>
          <MenuItem onClick={() => handleLocaleClose("en")}>English</MenuItem>
        </Menu>
      </nav>
    </header>
  );
};
